import React from 'react';
import styles from './Button.module.scss';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'darkGreen';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  loading?: boolean;
  children?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  loading = false,
  children,
  className,
  disabled,
  ...props
}) => {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : '',
    loading ? styles.loading : '',
    icon && !children ? styles.iconOnly : '',
    icon ? styles.hasIcon : '',
    icon && iconPosition === 'right' ? styles.iconRight : '',
    className || '',
  ]
    .join(' ')
    .trim();

  return (
    <button className={buttonClasses} disabled={disabled || loading} {...props}>
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {icon && (iconPosition === 'left' || !children) && !loading && (
        <span className={styles.icon}>{icon}</span>
      )}
      {children && <span className={styles.content}>{children}</span>}
      {icon && iconPosition === 'right' && children && !loading && (
        <span className={styles.icon}>{icon}</span>
      )}
    </button>
  );
};

export default Button;
